import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Positioning } from "./components/Positioning";
import { BrandsMarquee } from "./components/BrandsMarquee";
import { Services } from "./components/Services";
import { Espaco } from "./components/Espaco";
import { ImpactSection } from "./components/ImpactSection";
import { Story } from "./components/Story";
import { Team, Testimonials } from "./components/TeamTestimonials";
import { Booking } from "./components/Booking";
import { Footer } from "./components/ContactFooter";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { NewsletterPopup } from "./components/NewsletterPopup";
import { SEO } from "./components/SEO";
import { Analytics } from "./components/Analytics";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import ManageBooking from "./pages/ManageBooking";
import NewsletterUnsubscribe from "./pages/NewsletterUnsubscribe";
import EspacoPage from "./pages/EspacoPage";
import ContactosPage from "./pages/ContactosPage";

const Home = () => {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, []);

  return (
    <main>
      <Header />
      <Hero />
      <BrandsMarquee />
      <Positioning />
      <Services />
      <Espaco />
      <ImpactSection />
      <Story />
      <Team />
      <Testimonials />
      <Booking />
      <Footer />
      <WhatsAppButton />
      <NewsletterPopup />
    </main>
  );
};

function App() {
  return (
    <BrowserRouter>
      <SEO />
      <Analytics />
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/espaco" element={<EspacoPage />} />
        <Route path="/contactos" element={<ContactosPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/marcacao/:token" element={<ManageBooking />} />
        <Route path="/newsletter/cancelar/:token" element={<NewsletterUnsubscribe />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
